/** @file Canvas backing-store size for a CSS size and a device-pixel ratio (HiDPI). */

/** round(css × dpr) per axis, at least 1 px; a non-finite or non-positive dpr counts as 1, a bad size as 1 px. */
export function backingSize(width: number, height: number, dpr: number): { width: number; height: number } {
  const k = Number.isFinite(dpr) && dpr > 0 ? dpr : 1;
  const px = (css: number): number => {
    const v = Math.round(css * k);
    return Number.isFinite(v) && v >= 1 ? v : 1;
  };
  return { width: px(width), height: px(height) };
}
